import { render, staticRenderFns } from "./ApprovalDetail.vue?vue&type=template&id=799da618"
import script from "./ApprovalDetail.vue?vue&type=script&lang=js"
export * from "./ApprovalDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('799da618')) {
      api.createRecord('799da618', component.options)
    } else {
      api.reload('799da618', component.options)
    }
    module.hot.accept("./ApprovalDetail.vue?vue&type=template&id=799da618", function () {
      api.rerender('799da618', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/admin/ApprovalDetail.vue"
export default component.exports